import { createContext } from 'react';

const DEFAULT = {
  open: false,
  setOpen: (open: boolean) => {}
};

export const CommandPaletteContext = createContext(DEFAULT);
